var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"advantage-card"},[_c('div',{staticClass:"image"},[_c('img',{attrs:{"src":_vm.data.primaryImage.url,"alt":"features image"}})]),_c('div',{staticClass:"title"},[_vm._v(" "+_vm._s(_vm.data.title)+" ")]),_c('div',{staticClass:"content"},[_c('div',{domProps:{"innerHTML":_vm._s(_vm.data.content)}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }